import type { ProductStepId } from '../model/product-steps'

export type ProductFieldErrors = Partial<Record<string, string>>

export function stepForFieldPath(path: string): ProductStepId {
  if (
    path === 'name' ||
    path === 'description' ||
    path === 'supportEmail' ||
    path === 'supportName'
  ) {
    return 'basico'
  }
  if (path.startsWith('pixels.')) return 'tracking'
  if (path.startsWith('upsellWidgetStyle.')) return 'visual'
  if (path.startsWith('orderBumps.') || path.startsWith('funnelNodes.')) return 'funnel'
  if (path.startsWith('coupons.')) return 'cupons'
  if (path.startsWith('coproducers.')) return 'coproducao'
  if (path === 'split') return 'preco'
  if (path.startsWith('emailTemplate.')) return 'email'
  return 'preco'
}

export function stepHasFieldError(stepId: ProductStepId, errors: ProductFieldErrors) {
  return Object.keys(errors).some((path) => stepForFieldPath(path) === stepId)
}

export function firstStepWithError(errors: ProductFieldErrors): ProductStepId {
  const order: ProductStepId[] = [
    'basico',
    'preco',
    'visual',
    'funnel',
    'tracking',
    'cupons',
    'coproducao',
    'email',
  ]
  return order.find((step) => stepHasFieldError(step, errors)) ?? 'preco'
}

export function uniqueFieldErrorMessages(
  errors: ProductFieldErrors,
  step?: ProductStepId,
): string[] {
  const messages: string[] = []
  const seen = new Set<string>()
  for (const [path, message] of Object.entries(errors)) {
    if (step && stepForFieldPath(path) !== step) continue
    if (!message || seen.has(message)) continue
    seen.add(message)
    messages.push(message)
  }
  return messages
}
